<template>
  <table cellspacing="0" border="1" :class="$style['report-sign']">
    <tr>
      <td>
        <div class="sign">委托人签字：</div>
        <div class="content"></div>
        <div class="date">
          <div class="date-message">
            <div></div>
            年
            <div></div>
            月
            <div></div>
            日
          </div>
        </div>
      </td>
      <td>
        <div class="sign">受理人签字：</div>
        <div class="content"></div>
        <div class="date">
          <div class="date-message">
            <div></div>
            年
            <div></div>
            月
            <div></div>
            日
          </div>
        </div>
      </td>
    </tr>
  </table>
</template>
<script>
export default {};
</script>
<style module lang="less">
.report-sign {
  :global {
    .sign {
      text-align: left;
    }
    .content {
      height: 40px;
    }
    .date {
      .date-message {
        display: flex;
        text-align: end;
        justify-content: end;
        > div {
          width: 5em;
          height: 20px;
        }
      }
    }
  }
}
</style>
